


























































import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { capitalize } from '@getaccept/lib-shared/src/helpers';
import { DashboardWidgetHeaderColor } from '../types/enums/dashboard-widget-header-color';
import { DashboardWidgetValueColor } from '../types/enums/dashboard-widget-value-color';
import type { DashboardWidgets } from '../types/dashboard-widgets';
import type { DashboardActivity } from '../types/dashboard-activity';
import type { DashboardExpiringDocument } from '../types/dashboard-expiring-document';
import DashboardWidget from './DashboardWidget.vue';
import LatestActivitiesWidget from './widgets/latest-activity/LatestActivitiesWidget.vue';
import ExpiringSoonWidget from './widgets/expiring-soon/ExpiringSoonWidget.vue';
import DashboardBusinessSkeleton from './skeletons/DashboardBusinessSkeleton.vue';

export default defineComponent({
  components: {
    DashboardWidget,
    LatestActivitiesWidget,
    ExpiringSoonWidget,
    DashboardBusinessSkeleton,
  },
  props: {
    widgets: {
      type: Object as PropType<DashboardWidgets>,
      default: null,
    },
    activities: {
      type: Array as PropType<DashboardActivity[]>,
      default: null,
    },
    expiringDocuments: {
      type: Array as PropType<DashboardExpiringDocument[]>,
      default: null,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const countTitle = (value: number): string =>
      value === 1 ? t('document').toString() : t('documents').toString();

    return {
      DashboardWidgetHeaderColor,
      DashboardWidgetValueColor,
      countTitle,
      capitalize,
    };
  },
});
